import styled from "styled-components"

const FeedJobStyled = styled.div`
  .container__feed {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
  }
  .carrer__items {
   
    &--1 {
      justify-content: center;
      .feed__item {
        margin-right: 0;
      }
    }
    &--2 {
      justify-content: center;
    }
  }
  .feed__item {
    width: 100%;
    max-width: calc(33.33% - 36.66px);
    margin: 0 auto;

    @media (max-width: 1080px) {
      max-width: calc(33.33% - 14px);
    }
    @media (max-width: 880px) {
      max-width: calc(50% - 10px);
      width: calc(50% - 10px);
    }
    @media (max-width: 600px) {
      max-width: 100%;
      width: 100%;
    }
    &:nth-of-type(3n) {
      @media (max-width: 880px) {
        max-width: calc(50% - 10px);
        width: calc(50% - 10px);
      }
      @media (max-width: 600px) {
        max-width: 100%;
        width: 100%;
      }
    }
    &:nth-of-type(2n) {
      @media (max-width: 880px) {
        max-width: calc(50% - 10px);
        width: calc(50% - 10px);
      }
      @media (max-width: 600px) {
        max-width: 100%;
        width: 100%;
      }
    }
    &:nth-of-type(1n) {
      @media (max-width: 600px) {
        max-width: 100%;
        width: 100%;
      }
    }
    a {
      position: relative;
      z-index: 2;
      display: block;
      height: 100%;
    }
  }
  .feed__box {
    padding: 40px 30px 60px;
    @media (max-width: 880px) {
      padding: 20px 20px 40px;
    }
  }
  .feed__box__title {
    margin: 0 0 25px;
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    flex-direction: column;
    &:after {
      content: "";
      margin: 25px auto 0;
      display: inline-block;
      width: 70px;
      height: 1px;
      background: #707070;
    }
  }
  .feed__box__descirption {
    height: auto;
    margin: 0;
    padding-bottom: 25px;
  }
  .feed {
    padding-bottom: 70px;
  }
`

export default FeedJobStyled
